export default __webpack_public_path__ + "static/media/tiivii-guia-mobile-3.3b602f7d.png";